import * as React from 'react'
import { times } from 'lodash';
import MasonryGallery from 'src/share/components/Masonry/MasonryGallery';
import Button from 'reactstrap/lib/Button';
import ProgressiveImage from 'src/share/components/ProgressiveImage/ProgressiveImage';
import { SkeletonImage } from 'src/share/components/SkeletonImage/SkeletonImage';

const GSImageList = ({ images, totalResults, isFetching, onImageError, onRedirect, onLoadMore }) => {
  return (
    <div>
      <MasonryGallery>
        {[
          ...images,
          ...(isFetching
            ? times(1, (i) => ({
              imageUrl: "loading",
              page: ""
            }))
            : [])
        ].reduce((elements, element, index) => {
          if (element.imageUrl !== "loading") {
            const figure = (
              <figure key={`Figure-${element.id}`} className="geosearch-card">
                <ProgressiveImage
                  id={`geosearch-image-${index}`}
                  key={element.id}
                  className="geosearch-card__image"
                  preview={element.thumbnailUrl}
                  src={element.imageUrl}
                  onError={onImageError}
                  arachnid={element.knownChildAbuseImageArachnid}
                  height={element.height}
                  width={element.width}
                  status={element.status}
                  onRedirect={() => onRedirect(element.id)}
                />
                <div className="geosearch-card__text" onClick={() => onRedirect(element.id)}>
                  <span>Details</span>
                </div>
              </figure>
            );
            elements.push(figure);
          } else {
            elements.push(<div key={`Skeleton-${index}`} className="skeleton-transition" />);
            const skeleton = times(50, (i) => <SkeletonImage key={i} index={i} />);
            elements = [...elements, ...skeleton];
          }
          return elements;
        }, [] as any)}
      </MasonryGallery>
      {images.length > 0 && images.length < totalResults && (
        <div className="images-collection__load-more">
          <Button className="btn btn-gray btn-load-more" onClick={onLoadMore}>
            Load more
</Button>
        </div>
      )}
    </div>
  )
}

export default GSImageList;
